var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"achievement"},[_c('div',{staticClass:"achievement-container"},[_c('list-statistic',{attrs:{"statistics":_vm.statistics}}),_c('list-badge',{attrs:{"badges":_vm.badges}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }